import { Toaster, toast } from 'sonner';

export function Toast() {
  return (
    <Toaster
      position="top-right"
      expand={false}
      richColors
      closeButton
      toastOptions={{
        duration: 4000,
        className: 'text-sm',
      }}
    />
  );
}

// Re-export toast for use throughout the app
export { toast };

// Helper functions for common toast patterns
export const showSuccess = (message: string) => {
  toast.success(message);
};

export const showError = (message: string, description?: string) => {
  toast.error(message, { description });
};

export const showInfo = (message: string) => {
  toast.info(message);
};

export const showWarning = (message: string) => {
  toast.warning(message);
};

// Show API error with proper formatting
export const showApiError = (error: unknown) => {
  if (error instanceof Error) {
    // Check if it's an API error with details
    const apiError = error as { message: string; code?: string; details?: unknown };
    const message = apiError.message || 'An error occurred';
    const description = apiError.code ? `Error code: ${apiError.code}` : undefined;
    toast.error(message, { description });
  } else {
    toast.error('An unexpected error occurred');
  }
};
